import React, { useContext, useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import content from "../../services/content";

import DialogTitle from "@mui/material/DialogTitle";
import config from "../../config";
import { Close } from "@mui/icons-material";

import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import Iframe from "../Iframe";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "black",
    height: "100vh",
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },

  titleIcon: {
    height: theme.spacing(3),
    marginTop: theme.spacing(0.5),
  },
  title: {
    marginBottom: theme.spacing(-1),
    color: "white",
  },

  closeButton: {
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(1),
  },

  titleText: {
    marginLeft: theme.spacing(1),
    // fontWeight: "bold",
  },
  iframeContainer: {
    overflow: "hidden",
    paddingBottom: "56.25%",
    position: "relative",
    height: "0",
  },
}));

export default function HowToUseDialog(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  const [videoKey, setVideoKey] = useState("howToUse.video.");
  const [video, setVideo] = useState(content["howToUse.video"]["maharashtra"]);

  const theme = useTheme();
  const isLessThanSmall = useMediaQuery(theme.breakpoints.down('lg'));
  const fullScreen = isLessThanSmall;

  useEffect(() => {
    if (props.userState) {
      setVideo(
        content["howToUse.video"][props.userState.name_en.toLowerCase()]
      );
      setVideoKey(videoKey + props.userState.name_en.toLowerCase());
    } else {
      setVideo(content["howToUse.video"]["maharashtra"]);
      setVideoKey(videoKey + "maharashtra");
    }
  }, [props.userState]);

  return <>
    <Dialog
      fullWidth={true}
      fullScreen={fullScreen}
      onClose={props.handleClose}
      aria-labelledby="title"
      open={props.open}
    >
      <div className={classes.container}>
        <DialogTitle className={classes.title}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={1}>
              <img
                className={classes.titleIcon}
                src={`${config.appUrl}/icons/how-to-use-zoom.svg`}
                alt=""
              />
            </Grid>
            <Grid item xs={9}>
              <Typography
                gutterBottom
                variant="body1"
                className={classes.titleText}
              >
                {messages["dashboard.howToUse.sectionTitle"][language]}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton
                edge="end"
                aria-label="close"
                onClick={props.handleClose}
                className={classes.closeButton}
                color="inherit"
                size="large">
                <Close />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <div className={classes.iframeContainer}>
              <Iframe src={video?.video} />
            </div>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  </>;
}
